"use strict";

import initModulesInScope from '@elements/init-modules-in-scope';

export function initInScope($scope) {

    let $lists = $scope.find('.js-template-item-list');

    $lists.each(function() {
        let $list = $(this);
        let newId = 2;
        let $wrapper = $list.closest('.js-template-item-list__wrapper');
        let $addButton = $wrapper.find('.js-template-item-list__add');
        let name = $list.attr('data-template-item-list-name') || 'items';
        let $titleInitiallyHidden = $wrapper.find('.js-template-item-list__title');
        let $deleteButtons = $('.js-template-item-list__delete');

        $addButton.on('click', function(evt) {
            evt.preventDefault();

            let $template = $($list.find('.js-template-item-list__template').html());
            let $templateNew = $template.clone();

            if($titleInitiallyHidden) {
                $titleInitiallyHidden.removeAttr('hidden');
            }

            renderFormItem($templateNew, newId);

            $list.append($templateNew);

            initModulesInScope($lists);

            newId++;
            $templateNew.find('.js-template-item-list__delete').on('click', deleteItem);


        });

        $deleteButtons.on('click', deleteItem);

        function deleteItem() {
            $(this).closest('.js-template-item-list__item').remove();

            $('.js-template-item-list__item').each(function() {
                renderFormItem($(this), getElementIndex(this));
            });

            newId--;

            if($titleInitiallyHidden && newId === 2) {
                $titleInitiallyHidden.attr('hidden', 'hidden');
            }
        }

        function renderFormItem($template, newId) {
            $template.find('.js-template-item-list__form-item').each(function (index) {
                let $templateNew = $(this);

                let $itemInput = $templateNew.find('.js-template-item-list__item-input');

                //needed for datepicker
                let $itemElementWithId = $templateNew.find('.js-template-item-list__item-id');
                if($itemElementWithId) {
                    let itemElementId = $itemElementWithId.attr('id');
                    if(!$itemElementWithId.attr('data-template-item-list-default-id')) {
                        $itemElementWithId.attr('data-template-item-list-default-id', $itemElementWithId.attr('id'));
                    } else {
                        itemElementId = $itemElementWithId.attr('data-template-item-list-default-id');
                    }
                    $itemElementWithId.attr('id', itemElementId+'-'+newId);
                }

                let itemName = $itemInput.attr('name');

                if(!$itemInput.attr('data-template-item-list-default-name')) {
                    $itemInput.attr('data-template-item-list-default-name', $itemInput.attr('name'));
                } else {
                    itemName = $itemInput.attr('data-template-item-list-default-name');
                }

                let $itemLabel = $templateNew.find('.js-template-item-list__item-label');

                $itemLabel.attr('for', itemName+'-'+newId);
                $itemInput.attr('id', itemName+'-'+newId);
                $itemInput.attr('name', `${name}[${newId}][${itemName}]`);

            });


            $template.find('.js-template-item-list__item-count').html(newId);
        }

        function getElementIndex(element) {
            return [...element.parentNode.children].indexOf(element);
        }
    })
}
